export default class AddOnManager {
  static addOns = null;
  static setAddOns(data) {
    AddOnManager.addOns = data;
  }
  static getAddOns() {
    return AddOnManager.addOns;
  }
}
